import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

// Core Components
import PageNavbar from "../../components/navbars/PageNavbar";
import SiteFooter from "../../components/footers/SiteFooter";

function Route() {
  return (
    <>
      <PageNavbar />
      <div className="section features-6">
        <Container>
          <iframe
            id="mapmyfitness_route"
            src="//snippets.mapmycdn.com/routes/view/embedded/4077984529?width=800&height=450&elevation=true&info=true&line_color=E6cf530b&rgbhex=0b53cf&distance_markers=1&unit_type=metric&map_mode=ROADMAP&last_updated=2021-01-19T19:24:09+02:00&show_marker_every=5"
            height="800px"
            width="100%"
            frameborder="0"
          ></iframe>
        </Container>

        {/* <Container> */}
        {/* <iframe
          id="mapmyfitness_route"
          src="//snippets.mapmycdn.com/routes/view/embedded/4077984529?width=600&height=400&elevation=true&info=true&line_color=E6cf530b&rgbhex=0b53cf&distance_markers=1&unit_type=metric&map_mode=ROADMAP&last_updated=2021-01-19T19:24:09+02:00&show_marker_every=5"
          height="800px"
          width="100%"
          frameborder="0"
          style={{
            position: "relative",
            top: "0",
            left: "0",
            bottom: "0",
            right: "0",
            width: "100%",
            height: "100%",
            border: "none",
            margin: "0",
            padding: "0",
            overflow: "hidden",
            zIndex: "999999"
            //   display: "block",
            //   border: "none",
            //   height: "100vh",
            //   width: "90vw",
          }}
        ></iframe> */}
        {/* </Container> */}
      </div>
      <SiteFooter />
    </>
  );
}

export default Route;
